import useDefinedContext from "hooks/useDefinedContext";
import { createContext } from "react";
import type { MeasurementSet } from "types";

export interface ChartCompareSetSelectContextType {
  value: MeasurementSet[];
  onChange(sets: MeasurementSet[]): void;
  options: MeasurementSet[];
}

const ChartCompareSetSelectContext = createContext<ChartCompareSetSelectContextType | undefined>(undefined);
ChartCompareSetSelectContext.displayName = "ChartCompareSetSelectContext";

export function useChartCompareSetSelectContext() {
  return useDefinedContext(ChartCompareSetSelectContext);
}

export default ChartCompareSetSelectContext;
